import Link from "next/link";
import ArrowIcon from "@/components/icons/arrow";
import ExtendedImage from "@/components/ui/extended-image";
import type { Tool } from "./types";

const ToolCard = ({ data }: { data: Tool }) => {
  return (
    <li
      className="border relative h-50 max-h-50 max-w-full border-gray-300 rounded-2xl p-2 gap-2 flex flex-row justify-end"
      key={data.id}
    >
      <ExtendedImage
        alt={data.title}
        className="shrink-0 w rounded-2xl object-cover absolute -z-1 inset-0 w-full h-full"
        fill={true}
        src={data.image}
      />
      <div className="flex flex-col justify-center w-1/2">
        <h2 className="text-lg leading-5.5 font-bold">{data.title}</h2>
        <h2 className="text-[12px] leading-4.5 font-medium">
          {data.description}
        </h2>

        <Link
          className="mt-4 w-fit bg-brand-blue-600 text-white rounded-full flex px-6 py-2 gap-1 font-semibold"
          href={`/hesaplamalar/${data.slug}`}
        >
          Hesapla <ArrowIcon className="stroke-white" />
        </Link>
      </div>
    </li>
  );
};

export default ToolCard;
